<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="审批列表" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="审核类型">
									<el-select v-model="searchForm.sname" placeholder="请选择审核类型" clearable>
										<el-option v-for="item in options.sname_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
									<div v-if="!searchForm.sname"
										style="position: absolute;line-height: 16px;color: #f56c6c;font-size: 12px;">请先选择审核类型</div>
								</el-form-item>
								<el-form-item label="相关编码" v-if="searchForm.sname">
									<el-input v-model="searchForm.code" placeholder="请填写编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="审批内容">
									<el-input v-model="searchForm.title" placeholder="模糊搜索审批内容" clearable></el-input>
								</el-form-item>
								<el-form-item label="审批备注">
									<el-input v-model="searchForm.check_content" placeholder="模糊搜索审批备注" clearable></el-input>
								</el-form-item>
								<el-form-item label="提交人">
									<el-input v-model="searchForm.sub_name" placeholder="请填写提交人姓名" clearable></el-input>
								</el-form-item>
								<el-form-item label="所属部门">
									<el-cascader v-model="searchForm.dept_id" :options="options.dept_id_options"
										:props="{ checkStrictly: true, label: 'department_name', value: 'id' }" clearable></el-cascader>
								</el-form-item>
								<el-form-item label="提交日期">
									<el-date-picker clearable align="center" v-model="searchForm.time" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item label="审批日期">
									<el-date-picker clearable align="center" v-model="searchForm.update_time" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0; padding:8px 0 20px; display: block; height: auto;">
								<el-tabs v-model="activeNameCheck" @tab-click="handleCheckClick()">
									<el-tab-pane label="待审批的" name="first"></el-tab-pane>
									<el-tab-pane label="我提交的" name="second"></el-tab-pane>
									<el-tab-pane label="审核过的" name="third"></el-tab-pane>
									<el-tab-pane label="我结束的" name="fourth"></el-tab-pane>
								</el-tabs>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id"
									:tree-props="{ children: 'children', hasChildren: 'hasChildren' }" border stripe ref="table"
									v-loading="loading" highlight-current-row @sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed type="index" label="序号" width="50">
									</el-table-column>
									<el-table-column fixed prop="id" label="ID" width="50">
									</el-table-column>
									<el-table-column prop="sname" label="审批类型" width="100">
									</el-table-column>
									<el-table-column prop="code" label="相关编码" :render-header="renderCodeHeader" width="180">
									</el-table-column>
									<el-table-column prop="title" label="审批内容" min-width="220">
									</el-table-column>
									<el-table-column prop="sub_name" label="提交人" width="100">
									</el-table-column>
									<el-table-column prop="create_time" label="提交时间" width="150">
									</el-table-column>
									<el-table-column prop="check_rover" label="当前审批人" min-width="150">
									</el-table-column>
									<el-table-column prop="update_time" label="审批时间" width="150">
										<template slot-scope="scope">
											{{ scope.row.update_time ? scope.row.update_time : '--' }}
										</template>
									</el-table-column>
									<el-table-column prop="check_content" label="审批备注" min-width="100">
										<template slot-scope="scope">
											{{ scope.row.check_content ? scope.row.check_content : '--' }}
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="is_check" label="审核状态" width="80" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.is_check == 0" style="color: #409EFF;font-weight: bold;">待审核</span>
											<span v-if="scope.row.is_check == 1" style="color: #67c23a;font-weight: bold;">已通过</span>
											<span v-if="scope.row.is_check == 2" style="color: #67c23a;font-weight: bold;">已完结</span>
											<span v-if="scope.row.is_check == 3" style="color: #f56c6c;font-weight: bold;">已驳回</span>
											<span v-if="scope.row.is_check == 4" style="color: #f56c6c;font-weight: bold;">已退回上一步</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" align="center" width="110">
										<template slot-scope="scope">
											<el-button @click="handleTableEditOpen(scope.row, 'approve')" type="text" :size="size"
												v-if="scope.row.is_check == 0 && activeNameCheck == 'first'">审批</el-button>
											<el-button @click="handleTableEditOpen(scope.row, 'approveDetail')" type="text" :size="size"
												v-else>审批详情</el-button>
											<el-button @click="getLog(scope.row)" type="text" :size="size">日志</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[20, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--审批日志-->
		<el-dialog title="审批日志" :visible.sync="logVisiable" width="95%">
			<div class="kdialog">
				<el-table :data="logtableData.data" style="width: 100%" row-key="id" border stripe ref="tablelog"
					highlight-current-row>
					<el-table-column fixed prop="id" label="ID" min-width="50">
					</el-table-column>
					<el-table-column prop="flow_step_name" label="审核节点名称" min-width="100">
					</el-table-column>
					<el-table-column prop="title" label="审核内容" min-width="350">
					</el-table-column>
					<el-table-column prop="check_name" label="实际审核人" min-width="120">
					</el-table-column>
					<el-table-column prop="update_time" label="审核时间" width="150">
					</el-table-column>
					<el-table-column prop="create_time" label="创建时间" width="150">
						<template slot-scope="scope">
							{{ scope.row.update_time ? scope.row.update_time : '--' }}
						</template>
					</el-table-column>
					<el-table-column prop="check_content" label="审核意见" min-width="100">
						<template slot-scope="scope">
							{{ scope.row.check_content ? scope.row.check_content : '--' }}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			addFormVisiable: false,
			editFormVisiable: false,
			checkSkVisiable: false,
			logVisiable: false,
			loading: true,
			activeName: 'first',
			activeNameCheck: 'first',
			size: 'mini',
			options: {
				dept_id_options: [],
				sname_options: [],
			},
			searchForm: {
				sub_name: '',
				sname: '',
				code: '',
				check_content: '',
				title: '',
				update_time: '',
				type_id: 1,
				dept_id: '',
				time: []
			},
			resetSearch: {
				sub_name: '',
				sname: '',
				code: '',
				check_content: '',
				title: '',
				update_time: '',
				type_id: 1,
				dept_id: '',
				time: []
			},
			tableData: {
				total: 0,
				pagesize: 20,
				page: 1,
				data: []
			},
			logtableData: {
				data: []
			}
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 350;
		}
	},
	mounted: function () {
		this.getDepartmentOption()
		if (this.$route.query.type && this.$route.query.type == 1) {
			this.activeNameCheck = 'first'
		} else if (this.$route.query.type && this.$route.query.type == 2) {
			this.activeNameCheck = 'second'
		}
		//this.handleCheckClick()
		this.getSname()
	},
	methods: {
		renderCodeHeader (h, { column, $index }) {
			return h(
				'div',  // 这里应该是逗号 , 不是分号 ;
				[  // 数组应该在这里开始
					h('span', column.label),
					h(
						'el-tooltip',
						{
							props: {  // tooltip 的属性需要通过 props 传递
								// content: '第一行文字\n第二行文字\n第三行文字',
								placement: 'top'
							}
						},
						[  // tooltip 的内容
							h('i', {
								class: 'el-icon-question',
								style: 'color:#909399;margin-left:5px;cursor:pointer;'
							}),
							h('div', {
								slot: 'content',
								style: {
									textAlign: 'left',
									lineHeight: '1.5'
								}
							}, [
								h('div', '合同审批：合同编码'),
								h('div', '客户审批：客户编码'),
								h('div', '收票审批：收票申请编码'),
								h('div', '收款审批：收款申请编码'),
								h('div', '开票审批：开票申请编码'),
								h('div', '付款审批：付款申请编码'),
								h('div', '银行卡审批：银行卡号'),
								h('div', '发票信息审批：税号'),
								h('div', '退款审批：退款申请编码'),
								h('div', '客户退款审批：退款申请编码'),
								h('div', '撤销对账审批：执行编码'),
								h('div', '结案/反结案审批：项目编码'),
							])
						]
					)
				]
			)
		},
		getSname: function () {
			this.$api.get('/admin/examine/approve/getsname').then(res => {
				if (res.code === 0) {
					this.options.sname_options = res.data
				}
			})
		},
		reset: function () {
			this.searchForm = this.resetSearch;
			this.doSearch();
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/examine/approve/checklist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//切换审批状态
		handleCheckClick () {
			if (this.activeNameCheck == 'first') {
				this.searchForm.type_id = 1
			} else if (this.activeNameCheck == 'second') {
				this.searchForm.type_id = 2
			} else if (this.activeNameCheck == 'third') {
				this.searchForm.type_id = 3
			} else if (this.activeNameCheck == 'fourth') {
				this.searchForm.type_id = 4
			}
			this.handleSearch(this.searchForm)
		},
		//获取部门下拉
		getDepartmentOption () {
			this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
				if (res.code === 0) {
					this.options.dept_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//跳转审批详情
		handleTableEditOpen (row, type) {
			let name = ''
			if (row.set_id == 1) {
				//合同
				name = 'ContractDetail'
			} else if (row.set_id == 2) {
				//客户
				name = 'CustomerDetail'
			} else if (row.set_id == 3) {
				//申请收票
				name = 'InvoiceCollectDetail'
			} else if (row.set_id == 4) {
				//供应商
				name = 'SupplierDetail'
			} else if (row.set_id == 5) {
				//项目
				name = 'ProjectDetail'
			} else if (row.set_id == 6) {
				//发票录入
				name = 'EntryDetail'
			} else if (row.set_id == 7) {
				//资源
				name = 'ResourceDetail'
			} else if (row.set_id == 8) {
				//收款
				name = 'CollectionDetail'
			} else if (row.set_id == 9) {
				//申请开票
				name = 'OpenDetail'
			} else if (row.set_id == 11) {
				//银行卡
				name = 'BankcardDetail'
			} else if (row.set_id == 12) {
				//发票信息
				name = 'InvoiceDetail'
			} else if (row.set_id == 13) {
				//申请付款
				name = 'payCollectDetail'
			} else if (row.set_id == 14) {
				//申请结案
				name = 'payCollectDetail'
			} else if (row.set_id == 15) {
				//申请撤销对账
				name = 'cancelBillDetail'
			} else if (row.set_id == 16) {
				//退款申请
				name = 'RefundDetail'
			} else if (row.set_id == 17) {
				//修改成本
				name = 'CostDetail'
			} else if (row.set_id == 18) {
				//客户退款申请
				name = 'RefundDetail'
			} else if (row.set_id == 19) {
				//红冲申请
				name = 'HcDetail'
			}
			let params = {}
			if (type == 'approve') {
				params = {
					id: row.data_id,
					set_id: row.set_id,
					log_id: row.id,
					type: type
				}
			} else if (type == 'approveDetail') {
				params = {
					id: row.data_id,
					set_id: row.set_id,
					type: type
				}
			}
			this.$router.push({
				name: name,
				query: params
			});
		},
		//查看审批日志
		getLog (row) {
			this.loading = true
			this.$api.get('/admin/examine/approve/flowloglist', { set_id: row.set_id, data_id: row.data_id }).then(res => {
				if (res.code === 0) {
					this.logtableData.data = res.data;
					this.logVisiable = true
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (/etail/.test(from.path)) {
				try {
					vm.handleCheckClick();
				} catch (error) {
				}
			} else {
				vm.searchForm = JSON.parse(JSON.stringify(vm.resetSearch));
				vm.activeNameCheck = 'first'
				vm.handleCheckClick();
			}
		});
	}
}
</script>